import { componentStyles } from "./monday-products-homepage-first-fold-component.scss";
import ProductCards from "./product-cards/product-cards";
import SignupButton from "segments/desktop/core-components/button/signup-button/signup-button";
import Title from "segments/desktop/core-components/title/title";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import { useState } from "react";
import { WORK_OS_IRIS_COLOR_NAME } from "styles/color-consts";
import Colors from "/styles/colors";
import classnames from "classnames";
import { setCookie } from "services/cookies-service";
import {
  cookieValues,
  procuctIdToCluster
} from "segments/desktop/homepage-first-fold/layouts/monday-products-homepage-first-fold/consts";
import { CRM_PRODUCT_ID, DEV_PRODUCT_ID } from "constants/products";
import { updateUserClustersListWithMultipleClusters } from "/services/clusters-service";
import { HP_TAGS_SELECTION } from "constants/clusters";
import { CLUSTER_TYPE } from "constants/clusters/types";
import { INSTALL_PRODUCTS_FLOW, SKIP_AB_TESTS_HP, MULTIPLE_PRODUCTS_SELECTION } from "constants/cookies";
import ProductModal from "./product-modal/product-modal";
import { PRODUCT_MODAL_OPENED } from "/constants/bigbrain-event-types";
import { trackEvent } from "/services/bigbrain-service";

const MondayProductsHomepageFirstFoldComponent = (props) => {
  const {
    isV2,
    fullParagraph,
    subTitle,
    products,
    fullParagraphAdvancedConfig,
    TitleAdvancedConfig,
    translate,
    buttonConfig,
    marginAboveCards,
    marginBelowCards,
    distanceOfBottomPartFromTop,
    cardBackSidePaddingTop,
    logoWidth,
    cardWidth,
    departmentsTitle,
    departmentsHeight,
    removeSignupButton,
    version,
    modalTitle,
    modalSubTitle,
    checkBoxInsteadOfModal,
    removeCheckbox,
    cancelFlip,
    setCardImageAsBackground
  } = props;
  const [selectedProductColors, setSelectedProductColors] = useState(new Array(products?.length).fill(null));
  const [buttonClicked, setButtonClicked] = useState(false);
  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [product, setProduct] = useState(null);

  const openModal = (product) => {
    setProduct(product);
    setIsModalOpen(true);
    trackEvent(PRODUCT_MODAL_OPENED, {
      kind: product?.productType
    });
  };

  const closeProductModal = () => {
    setIsModalOpen(false);
  };

  const handleCardClick = (productType, stopButtonAnimation) => {
    if (!stopButtonAnimation) {
      setButtonClicked(true);
      setTimeout(() => {
        setButtonClicked(false);
      }, 500);
    }

    setSelectedProductIds((prevProductIds) => {
      if (prevProductIds.includes(productType)) {
        // If the product type is already in the array, remove it
        return prevProductIds.filter((id) => id !== productType);
      } else {
        // If the product type is not in the array, add it
        return [...prevProductIds, productType];
      }
    });
  };

  const getGradient = () => {
    const nonNullColors = selectedProductColors.filter((color) => color !== null);
    if (nonNullColors.length === 0) {
      return Colors[WORK_OS_IRIS_COLOR_NAME];
    } else if (nonNullColors.length === 1) {
      return `linear-gradient(to right, ${nonNullColors[0]}, ${nonNullColors[0]})`;
    } else {
      const chunkSize = 100 / (nonNullColors.length - 1);
      let gradientString = "linear-gradient(to right, ";
      nonNullColors.forEach((color, index) => {
        gradientString += color + (index < nonNullColors.length - 1 ? ` ${chunkSize * index}%, ` : " 100%");
      });
      return gradientString + ")";
    }
  };

  const getValidProductId = () => {
    if (selectedProductIds.length === 1) {
      const productId = selectedProductIds[0];
      if (productId === CRM_PRODUCT_ID || productId === DEV_PRODUCT_ID) {
        return productId;
      }
    }
    return null;
  };

  const getProductsCookiesKey = () => {
    if (selectedProductIds.length === 1) {
      return selectedProductIds[0];
    }
    if (selectedProductIds.length === 2) {
      const sortedIds = selectedProductIds.sort();
      return `${sortedIds[0]}_${sortedIds[1]}`;
    }
    return null;
  };

  const updateClusters = () => {
    const res = [];
    if (selectedProductIds.length < 3) {
      selectedProductIds.forEach((id) => {
        const clusterId = procuctIdToCluster[id];
        if (clusterId) res.push({ clusterId, clusterType: CLUSTER_TYPE });
      });
      updateUserClustersListWithMultipleClusters(res, HP_TAGS_SELECTION);
    }
  };

  const addTestCookiesAndClusters = (cookieKey) => {
    setCookie(SKIP_AB_TESTS_HP, true, {
      expires: 1 // 1 day
    });
    setCookie(MULTIPLE_PRODUCTS_SELECTION, true, {
      expires: 1 // 1 day
    });
    const productsKey = cookieKey || getProductsCookiesKey();
    if (productsKey) {
      const cookieArray = cookieValues[productsKey];
      cookieArray?.forEach((cookie) => {
        setCookie(cookie.key, cookie.value, {
          expires: 1 // 1 day
        });
      });
    } else {
      setCookie(INSTALL_PRODUCTS_FLOW, false, {
        expires: 1 // 1 day
      });
    }
    updateClusters();
  };

  return (
    <div className="monday-products-homepage-first-fold-component" style={{ "--background": getGradient() }}>
      <FullParagraph {...fullParagraph} {...fullParagraphAdvancedConfig} />

      <Title {...subTitle} {...TitleAdvancedConfig} />

      <div className="product-cards-wrapper" style={{ marginTop: marginAboveCards, marginBottom: marginBelowCards }}>
        <ProductCards
          departmentsTitle={departmentsTitle}
          products={products}
          cardWidth={cardWidth}
          departmentsHeight={departmentsHeight}
          setSelectedProductColors={setSelectedProductColors}
          handleCardClick={handleCardClick}
          translate={translate}
          distanceOfBottomPartFromTop={distanceOfBottomPartFromTop}
          cardBackSidePaddingTop={cardBackSidePaddingTop}
          logoWidth={logoWidth}
          isV2={isV2}
          beforeSubmitCallback={addTestCookiesAndClusters}
          openModal={openModal}
          version={version}
          isModalOpen={isModalOpen}
          checkBoxInsteadOfModal={checkBoxInsteadOfModal}
          removeCheckbox={removeCheckbox}
          cancelFlip={cancelFlip}
          setCardImageAsBackground={setCardImageAsBackground}
        />
      </div>
      {!removeSignupButton && (
        <div className={classnames("signup-button-wrapper", { "card-selected": buttonClicked })}>
          <SignupButton
            {...buttonConfig}
            signupProductId={getValidProductId()}
            beforeSubmitCallback={addTestCookiesAndClusters}
            extraData={{ selectedProducts: selectedProductIds }}
            skipUpdateCluster={true}
          />
        </div>
      )}
      <ProductModal
        isModalOpen={isModalOpen}
        closeProductModal={closeProductModal}
        product={product}
        translate={translate}
        beforeSubmitCallback={addTestCookiesAndClusters}
        modalTitle={modalTitle}
        modalSubTitle={modalSubTitle}
      />
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default MondayProductsHomepageFirstFoldComponent;
